import { initKlarnaOnsiteMessaging } from "../modules/klarna-messaging";

function initKlarnaPage() {
  initKlarnaOnsiteMessaging();
}

initKlarnaPage();
